export const COLORS = {
  purpleLight: "#b74cff",
  purpleDark: "#b74cff",
  blueDark: "#6c84ff",
  yellowDark: "#f1853d",
  yellowLight: "#eef13d",
  blueLight: "#96b0ff",
};
